import { gql } from '@apollo/client'

export const SEND_USER_INVITE = gql`
  query sendUserInvite($email: String!) {
    sendUserInvite(email: $email) {
      success
    }
  }
`
